// Zero-width space — invisible, but a real character that breaks the
// continuous text node iOS Safari scans for "addresses" / "dates".
const ZWSP = '​';

/**
 * Break up iOS Safari "Data Detectors" matches in an item title.
 *
 * iOS scans a continuous text node and wraps anything that looks like an
 * address / date / phone (e.g. a card name like
 * "2014 PANINI PRIZM DON MATTINGLY 163 PSA 9" — a year + words reads as a
 * date/address) in a tappable, dotted-underlined link. `format-detection`
 * doesn't cover addresses, so the reliable fix is to interrupt the pattern:
 * we insert a zero-width space AFTER each space, so the multi-token
 * "number + words" run is no longer one continuous match.
 *
 * The ZWSP sits right next to a real space (already a valid break point), so
 * the VISIBLE text, wrapping and width are unchanged, and nothing is inserted
 * inside words. Render-only — never mutate the stored/analytics string.
 */
export function suppressDataDetectors(text: string): string {
  return text.replace(/ /g, ` ${ZWSP}`);
}
